import { render, staticRenderFns } from "./clientModal.vue?vue&type=template&id=0cbd22f9&scoped=true&"
import script from "./clientModal.vue?vue&type=script&lang=js&"
export * from "./clientModal.vue?vue&type=script&lang=js&"
import style0 from "./clientModal.vue?vue&type=style&index=0&id=0cbd22f9&prod&scoped=true&lang=css&"
import style1 from "./clientModal.vue?vue&type=style&index=1&id=0cbd22f9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbd22f9",
  null
  
)

export default component.exports